import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Eye } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ImpersonationBanner = () => {
  const { isImpersonating, impersonatedUser, stopImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const handleReturnToAdmin = () => {
    stopImpersonation();
    // Use setTimeout to ensure state updates before navigation
    setTimeout(() => {
      navigate('/admin');
    }, 100);
  };

  return (
    <div
      className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between z-[100] sticky top-0"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2 text-sm font-medium">
        <Eye className="w-4 h-4" />
        <span>
          Viewing as <strong>{impersonatedUser?.business_name || impersonatedUser?.email}</strong>
        </span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleReturnToAdmin}
        className="text-white hover:bg-amber-600 hover:text-white font-medium"
        data-testid="stop-impersonation-btn"
      >
        <ArrowLeft className="w-4 h-4 mr-1" />
        Return to Admin
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
